import React from "react";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import SlidingPane from "react-sliding-pane";
import di from "@di";
import { useDispatch } from "react-redux";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
const TocHoc = (props) => {
    const device = DeviceContext();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(true);
    const removeMarginData = () => {
        tocDi.tocJourney.flushMarginData();
        tocDi.tocJourney.flushMultiQuoteData();
    };
    React.useEffect(() => {
        if (device) {
            if ((device === null || device === void 0 ? void 0 : device.isDesktop) && !props.hideHeader) {
                di.header.RemoveHeaderData(true);
                dispatch(di.footer.setShowFooterUi(true));
            }
            else {
                di.header.RemoveHeaderData(false);
                dispatch(di.footer.setShowFooterUi(false));
                dispatch(di.footer.updateShowMob_Menu(false));
            }
        }
    }, [device, props.hideHeader]);
    React.useEffect(() => {
        return () => {
            removeMarginData();
        };
    }, []);
    return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(SlidingPane, { hideHeader: true, overlayClassName: "stock-details-overlayblock", className: "toc-sliding-pane", isOpen: open, from: "right", onRequestClose: () => {
            var _a;
            (_a = document
                .getElementsByClassName("stock-details")[0]) === null || _a === void 0 ? void 0 : _a.classList.add("hideDetailSection");
            (props === null || props === void 0 ? void 0 : props.outsideClick) && (props === null || props === void 0 ? void 0 : props.outsideClick(false));
            setTimeout(() => {
                setOpen(false);
            }, 700);
            removeMarginData();
        } },
        React.createElement("div", { className: "toc stock-details" },
            React.createElement("div", { className: `toc stock-details-head bg_aqua_white w-100 p-0` },
                React.createElement("div", { className: "stock-details-switch-key txt-midnight-blue", onClick: () => {
                        var _a;
                        (_a = document
                            .getElementsByClassName("stock-details")[0]) === null || _a === void 0 ? void 0 : _a.classList.add("hideDetailSection");
                        setOpen(false);
                        (props === null || props === void 0 ? void 0 : props.outsideClick) && (props === null || props === void 0 ? void 0 : props.outsideClick(false));
                    } },
                    React.createElement("i", { className: "edel-icon-arrow-right1" }))),
            React.createElement(props.component, Object.assign({}, props))))) : (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isMobile) && React.createElement(props.component, Object.assign({}, props))))));
};
export default TocHoc;
